import axios from "axios";

const getList = (query) => {
  const params = new URLSearchParams(query).toString();
  const response = axios({
    url:`attendances/${query.pageName}/?${params}`,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    return response.data
  })
  return response
}

const updateStatus = (formData) => {
  const response = axios({
    url:`attendances/leaveAction`,
    method:"POST",
    data:formData,
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    return response.data
  })
  return response
}

const leavesService = {
  getList,
  updateStatus
}

export default leavesService;